import React from 'react';

import { Grid } from '@hbf/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { ImageGridColSkeleton } from './ImageGridColSkeleton';
import { ImageGridContainer } from './ImageGridContainer';

interface Props {
  numPhotos: number;
}

export const ImageGridSkeleton: React.FC<Props> = ({ numPhotos }) => {
  const { md } = useMediaQuery();
  const hasSecondCol = numPhotos > 1 && md;

  return (
    <ImageGridContainer>
      <Grid item xs={hasSecondCol ? 6 : 12}>
        <ImageGridColSkeleton numPhotos={1} />
      </Grid>

      {hasSecondCol ? (
        <Grid item xs={6}>
          <ImageGridColSkeleton numPhotos={numPhotos - 1} />
        </Grid>
      ) : null}
    </ImageGridContainer>
  );
};
